import React from 'react';
import template from './TaxesHeader.rt';
import TaxesRegions from "./TaxesRegions";

export default class TaxesHeader extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      dropDownVisible: false
    };

    this.dropDownRef = null;
  }

  showDropDown = show => {
    this.setState({dropDownVisible: show}, () => {
      if (show)
        this.dropDownRef.focus();
    });
  }

  selectGroup = group => {
    //TaxesRegions.currentRegion.setCurrentGroupAtLevel(this.props.level, group);
    this.showDropDown(false);
    const {taxRegion} = this.props;
    this.props.setFilterGroup(taxRegion.name, group);
  }

  render = template;
};

